var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { closeLoading, showLoading, useUI } from '@/store';
import { getLocalStorage, getObjListByKey } from '@/utils';
import { useState } from 'react';
export const usePreloader = () => {
    const uiCtx = useUI();
    const [isPreloading, setIsPreloading] = useState(false);
    const [preloadPercent, setPreloadPercent] = useState(0);
    const [imagesPreloaded, setImagesPreloaded] = useState({});
    const [errors, setErrors] = useState([]);
    const { api_url } = getLocalStorage();
    const loadImage = (item) => new Promise((resolve) => {
        const image = new Image();
        image.id = item.id;
        image.src = item.src;
        image.onload = () => resolve(true);
        image.onerror = () => {
            setErrors((prev) => [...prev, item]);
            resolve(false);
        };
    });
    const preloadImages = (mediaList = []) => __awaiter(void 0, void 0, void 0, function* () {
        if (mediaList.length === 0) {
            return true;
        }
        try {
            setIsPreloading(true);
            uiCtx.dispatch(showLoading({ progress: 0 }));
            const images = mediaList.map((x) => (Object.assign(Object.assign({}, x), { src: api_url + x.src })));
            const increment = 100 / images.length;
            let loadedCount = 0;
            for (const item of images) {
                yield loadImage(item);
                loadedCount++;
                const progress = Math.min(Math.round(loadedCount * increment), 100);
                setPreloadPercent(progress);
                uiCtx.dispatch(showLoading({ progress }));
            }
            setImagesPreloaded(getObjListByKey(images, 'key'));
            return true;
        }
        catch (error) {
            console.error('Image preloading error:', error);
            return false;
        }
        finally {
            uiCtx.dispatch(closeLoading());
            setIsPreloading(false);
        }
    });
    return [
        imagesPreloaded,
        {
            isPreloadFailed: errors.length > 0,
            isPreloading,
            preloadImages,
            preloadPercent
        }
    ];
};
export default usePreloader;
